import { TradingAccount as RawTradingAccount, TRADING_ACCOUNT_PLATFORM_NAMES } from '@fsd/shared/api';
import { ROUTES } from '@fsd/shared/constants/routes';
import { TradingAccount as MappedTradingAccount, WEB_TERMINAL_PLATFORMS } from '../../types';

export const tradingAccountMapper = (tradingAccounts: RawTradingAccount[]): MappedTradingAccount[] => tradingAccounts
  .map(({ id, attributes }) => ({
    id,
    login: attributes.login,
    number: attributes.number,
    type: attributes.type,
    platformName: attributes.platform.name,
    platformHumanName: attributes.platform.humanName,
    platformDisplayName: attributes.platform.name === TRADING_ACCOUNT_PLATFORM_NAMES.MT4 ? 'mt4' : attributes.platform.name,
    webTerminal: {
      name: ROUTES.MT_WEB.NAME,
      params: {
        type: WEB_TERMINAL_PLATFORMS[attributes.platform.name],
      },
      query: {
        login: attributes.login,
      },
    },
    balance: {
      ...attributes.balance,
      bonus: attributes.bonus,
      equity: attributes.equity,
    },
    accountDetails: {
      leverage: attributes.leverage,
      accountLeverageRequestIsActive: attributes.accountLeverageRequestIsActive,
      accountLeverageRequestValue: attributes.accountLeverageRequestValue,
      accountGroupRequestIsActive: attributes.accountGroupRequestIsActive,
      accountGroupRequestValue: attributes.accountGroupRequestValue,
      canCreateReportRequest: attributes.canCreateReportRequest,
    },
  }));
